import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "popup-main",
  style: {
    "margin-top": "20px",
    "padding-top": "20px"
  }
};
var _hoisted_2 = {
  class: "popup-result"
};
var _hoisted_3 = {
  class: "popup-main",
  style: {
    "margin-top": "20px",
    "padding-top": "20px"
  }
};
var _hoisted_4 = {
  class: "popup-result"
};
var _hoisted_5 = {
  class: "pop_btn"
};
import CronParser from 'cron-parser';
import Moment from 'moment';
import CrontabSecond from './Crontab-Second.vue';
import CrontabMin from './Crontab-Min.vue';
import CrontabHour from './Crontab-Hour.vue';
import CrontabDay from './Crontab-Day.vue';
import CrontabMonth from './Crontab-Month.vue';
import CrontabWeek from './Crontab-Week.vue';
import CrontabYear from './Crontab-Year.vue';

import { computed, watch, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Crontab',
  props: {
    expression: {
      default: ''
    },
    hideComponent: {
      default: []
    }
  },
  emits: ['hide', 'fill'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var tabTitles = ['秒', '分钟', '小时', '日', '月', '周', '年'];
    var refs = ref({});
    var contabValueObj = ref({
      second: '*',
      min: '*',
      hour: '*',
      day: '*',
      month: '*',
      week: '?',
      year: ''
    });
    var nextFireTimes = ref([]);
    var contabValueString = computed(function () {
      var obj = contabValueObj.value;
      return obj.second + ' ' + obj.min + ' ' + obj.hour + ' ' + obj.day + ' ' + obj.month + ' ' + obj.week + (obj.year === '' ? '' : ' ' + obj.year);
    });
    watch(function () {
      return props.expression;
    }, function () {
      resolveExp();
    });
    watch(contabValueString, function (newValue) {
      refreshNextFireTimes(newValue);
    });
    onMounted(function () {
      resolveExp();
    });
    function shouldHide(key) {
      return !(props.hideComponent && props.hideComponent.includes(key));
    }
    function resolveExp() {
      nextFireTimes.value = [];
      // 反解析 表达式
      if (props.expression) {
        var arr = props.expression.split(' ');
        if (arr.length >= 6) {
          // 6 位以上是合法表达式
          var obj = {
            second: arr[0],
            min: arr[1],
            hour: arr[2],
            day: arr[3],
            month: arr[4],
            week: arr[5],
            year: arr[6] ? arr[6] : ''
          };
          contabValueObj.value = _objectSpread({}, obj);
          for (var i in obj) {
            if (obj[i]) {
              changeRadio(i, obj[i]);
            }
          }
          refreshNextFireTimes(props.expression);
        }
      } else {
        // 没有传入的表达式 则还原
        clearCron();
      }
    }
    function refreshNextFireTimes(expression) {
      nextFireTimes.value = [];
      try {
        var interval = CronParser.parseExpression(expression);
        while (interval.hasNext() && nextFireTimes.value.length < 3) {
          nextFireTimes.value.push(Moment(interval.next().toDate()).format('YYYY-MM-DD HH:mm:ss'));
        }
      } catch (error) {
        console.error(error);
      }
    }
    // 由子组件触发，更改表达式组成的字段值
    function updateContabValue(name, value, from) {
      contabValueObj.value[name] = value;
      if (from && from !== name) {
        console.log("\u6765\u81EA\u7EC4\u4EF6 ".concat(from, " \u6539\u53D8\u4E86 ").concat(name, " ").concat(value));
        changeRadio(name, value);
      }
    }
    // 赋值到组件
    function changeRadio(name, value) {
      var arr = ['second', 'min', 'hour', 'month'];
      var refName = 'cron' + name;
      var insVlaue;
      if (!refs.value[refName]) return;
      if (arr.includes(name)) {
        if (value === '*') {
          insVlaue = 1;
        } else if (value.indexOf('-') > -1) {
          var indexArr = value.split('-');
          isNaN(indexArr[0]) ? refs.value[refName].cycle01 = 0 : refs.value[refName].cycle01 = indexArr[0];
          refs.value[refName].cycle02 = indexArr[1];
          insVlaue = 2;
        } else if (value.indexOf('/') > -1) {
          var _indexArr = value.split('/');
          isNaN(_indexArr[0]) ? refs.value[refName].average01 = 0 : refs.value[refName].average01 = _indexArr[0];
          refs.value[refName].average02 = _indexArr[1];
          insVlaue = 3;
        } else {
          insVlaue = 4;
          refs.value[refName].checkboxList = value.split(',');
        }
      } else if (name === 'day') {
        if (value === '*') {
          insVlaue = 1;
        } else if (value === '?') {
          insVlaue = 2;
        } else if (value.indexOf('-') > -1) {
          var _indexArr2 = value.split('-');
          isNaN(_indexArr2[0]) ? refs.value[refName].cycle01 = 0 : refs.value[refName].cycle01 = _indexArr2[0];
          refs.value[refName].cycle02 = _indexArr2[1];
          insVlaue = 3;
        } else if (value.indexOf('/') > -1) {
          var _indexArr3 = value.split('/');
          isNaN(_indexArr3[0]) ? refs.value[refName].average01 = 0 : refs.value[refName].average01 = _indexArr3[0];
          refs.value[refName].average02 = _indexArr3[1];
          insVlaue = 4;
        } else if (value.indexOf('W') > -1) {
          var _indexArr4 = value.split('W');
          isNaN(_indexArr4[0]) ? refs.value[refName].workday = 0 : refs.value[refName].workday = _indexArr4[0];
          insVlaue = 5;
        } else if (value === 'L') {
          insVlaue = 6;
        } else {
          refs.value[refName].checkboxList = value.split(',');
          insVlaue = 7;
        }
      } else if (name === 'week') {
        if (value === '*') {
          insVlaue = 1;
        } else if (value === '?') {
          insVlaue = 2;
        } else if (value.indexOf('-') > -1) {
          var _indexArr5 = value.split('-');
          isNaN(_indexArr5[0]) ? refs.value[refName].cycle01 = 0 : refs.value[refName].cycle01 = _indexArr5[0];
          refs.value[refName].cycle02 = _indexArr5[1];
          insVlaue = 3;
        } else if (value.indexOf('#') > -1) {
          var _indexArr6 = value.split('#');
          isNaN(_indexArr6[0]) ? refs.value[refName].average01 = 1 : refs.value[refName].average01 = _indexArr6[0];
          refs.value[refName].average02 = _indexArr6[1];
          insVlaue = 4;
        } else if (value.indexOf('L') > -1) {
          var _indexArr7 = value.split('L');
          isNaN(_indexArr7[0]) ? refs.value[refName].weekday = 1 : refs.value[refName].weekday = _indexArr7[0];
          insVlaue = 5;
        } else {
          refs.value[refName].checkboxList = value.split(',');
          insVlaue = 7;
        }
      } else if (name === 'year') {
        if (value === '') {
          insVlaue = 1;
        } else if (value === '*') {
          insVlaue = 2;
        } else if (value.indexOf('-') > -1) {
          insVlaue = 3;
        } else if (value.indexOf('/') > -1) {
          insVlaue = 4;
        } else {
          refs.value[refName].checkboxList = value.split(',');
          insVlaue = 5;
        }
      }
      refs.value[refName].radioValue = insVlaue;
    }
    // 表单选项的子组件校验数字格式（通过-props传递）
    function checkNumber(value, minLimit, maxLimit) {
      // 检查必须为整数
      value = Math.floor(value);
      if (value < minLimit) {
        value = minLimit;
      } else if (value > maxLimit) {
        value = maxLimit;
      }
      return value;
    }
    // 隐藏弹窗
    function hidePopup() {
      emits('hide');
    }
    // 填充表达式
    function submitFill() {
      emits('fill', contabValueString.value);
      hidePopup();
    }
    function clearCron() {
      // 还原选择项
      '准备还原';
      contabValueObj.value = {
        second: '*',
        min: '*',
        hour: '*',
        day: '*',
        month: '*',
        week: '?',
        year: ''
      };
      for (var j in contabValueObj.value) {
        changeRadio(j, contabValueObj.value[j]);
      }
      nextFireTimes.value = [];
    }
    return function (_ctx, _cache) {
      var _component_el_tab_pane = _resolveComponent("el-tab-pane");
      var _component_el_tabs = _resolveComponent("el-tabs");
      var _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_tabs, {
        type: "border-card"
      }, {
        default: _withCtx(function () {
          return [shouldHide('second') ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            label: "秒"
          }, {
            default: _withCtx(function () {
              return [_createVNode(CrontabSecond, {
                ref: "cronsecond",
                check: checkNumber,
                onUpdate: updateContabValue
              }, null, 512)];
            }),
            _: 1
          })) : _createCommentVNode("", true), shouldHide('min') ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 1,
            label: "分钟"
          }, {
            default: _withCtx(function () {
              return [_createVNode(CrontabMin, {
                ref: function ref(e) {
                  _unref(refs).cronmin = e;
                },
                check: checkNumber,
                cron: _unref(contabValueObj),
                onUpdate: updateContabValue
              }, null, 8, ["cron"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), shouldHide('hour') ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 2,
            label: "小时"
          }, {
            default: _withCtx(function () {
              return [_createVNode(CrontabHour, {
                ref: function ref(e) {
                  _unref(refs).cronhour = e;
                },
                check: checkNumber,
                cron: _unref(contabValueObj),
                onUpdate: updateContabValue
              }, null, 8, ["cron"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), shouldHide('day') ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 3,
            label: "日"
          }, {
            default: _withCtx(function () {
              return [_createVNode(CrontabDay, {
                ref: function ref(e) {
                  _unref(refs).cronday = e;
                },
                check: checkNumber,
                cron: _unref(contabValueObj),
                onUpdate: updateContabValue
              }, null, 8, ["cron"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), shouldHide('month') ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 4,
            label: "月"
          }, {
            default: _withCtx(function () {
              return [_createVNode(CrontabMonth, {
                ref: function ref(e) {
                  _unref(refs).cronmonth = e;
                },
                check: checkNumber,
                cron: _unref(contabValueObj),
                onUpdate: updateContabValue
              }, null, 8, ["cron"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), shouldHide('week') ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 5,
            label: "周"
          }, {
            default: _withCtx(function () {
              return [_createVNode(CrontabWeek, {
                ref: function ref(e) {
                  _unref(refs).cronweek = e;
                },
                check: checkNumber,
                cron: _unref(contabValueObj),
                onUpdate: updateContabValue
              }, null, 8, ["cron"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), shouldHide('year') ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 6,
            label: "年"
          }, {
            default: _withCtx(function () {
              return [_createVNode(CrontabYear, {
                ref: function ref(e) {
                  _unref(refs).cronyear = e;
                },
                check: checkNumber,
                cron: _unref(contabValueObj),
                onUpdate: updateContabValue
              }, null, 8, ["cron"])];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "title"
      }, "计划执行表达式", -1)), _createElementVNode("table", null, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabTitles, function (item) {
        return _createElementVNode("th", {
          key: item,
          width: "40"
        }, _toDisplayString(item), 1);
      }), 64)), _cache[0] || (_cache[0] = _createElementVNode("th", null, "Cron表达式", -1))])]), _createElementVNode("tbody", null, [_createElementVNode("tr", null, [_createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_unref(contabValueObj).second), 1)]), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_unref(contabValueObj).min), 1)]), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_unref(contabValueObj).hour), 1)]), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_unref(contabValueObj).day), 1)]), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_unref(contabValueObj).month), 1)]), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_unref(contabValueObj).week), 1)]), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_unref(contabValueObj).year), 1)]), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_unref(contabValueString)), 1)])])])])])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "title"
      }, "计划执行时间", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nextFireTimes), function (time) {
        return _openBlock(), _createElementBlock("div", {
          key: time
        }, _toDisplayString(time), 1);
      }), 128))])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: submitFill
      }, {
        default: _withCtx(function () {
          return _cache[3] || (_cache[3] = [_createTextVNode("确定")]);
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: clearCron
      }, {
        default: _withCtx(function () {
          return _cache[4] || (_cache[4] = [_createTextVNode("重置")]);
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: hidePopup
      }, {
        default: _withCtx(function () {
          return _cache[5] || (_cache[5] = [_createTextVNode("取消")]);
        }),
        _: 1
      })])]);
    };
  }
});